export default {
  hero: {
    simple:
      "Découvrez Nesto: la solution simple et intelligente pour devenir propriétaire plus rapidement",
    rate: "Meilleur Taux Hypothécaire. Point Final.",
    subtitle:
      "Découvrez Nesto: la solution simple et intelligente pour devenir propriétaire plus rapidement",
    footnote:
      "Accès instantané aux meilleurs taux de 20+ institutions financières",
    cta_new: "NOUVELLE HYPOTHÈQUE",
    cta_renewal: "RENOUVELLEMENT"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/fr/hero.js